/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoFacebookIcon20Solid = forwardRef('LogoFacebookIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.652 10.445 15.184 7H12V5.873C12 4.925 12.31 4 13.8 4H15V1.048S13.952.813 12.64.813C9.898.813 8 2.474 8 5.481V7H5v3.445h3V18h4v-7.555h2.652Z" })));
});
